import { useEffect, useMemo, useState } from "react";
import { getRealTimeCallApi } from "../../../api/sipData";
import { useLoading } from "../../../context/LoadingContext";
import { ToastType, useToast } from "../../../context/ToastContext";
import CafeJavaLogo from "../../../assets/cafeJavas-logo.png";
import MusadanLogo from "../../assets/musadan-new-icon.png";
import EminPashaLogo from "../../assets/emin-pasha.png";
import JlosLogo from "../../assets/jlos-new-logo.png";
import RahimLogo from "../../assets/rahim-foods.jpeg";
import ShellLogo from "../../../assets/shell-2020.png"
import GsRestaurantLogo from "../../assets/gs-resturant-transparent.png";
import FirstPharmacyLogo from "../../assets/Screenshot_2025-01-15_at_21.38.23-removebg-preview.png";
import RamaLogo from "../../../assets/rama.png";
import { getAuthData } from "../../../shared/utils/localStorage";
import { CompanyDataProps, SipDataProps } from "../../../shared/types/type";
import { useSIPProvider } from "../../../sip/SIPProviderContext";
import { CONNECT_STATUS, RegisterStatus, SIPAccount } from "../../../sip/type";
import { isPlatform } from "@ionic/react";
import { getCordovaAuthData } from "../../../shared/utils/secureTokenService";
import { UserProfileProps } from "../../../api/auth/login";
import { logoutUser } from "../../../shared/utils/authUser";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getAllOrganizations } from "../../../api/organization";

export const registeredCompanies: CompanyDataProps[] = [
  {
    id: 1,
    name: "Musadan",
    description: `Musadan is dedicated to transforming the way organizations handle customer support and
    knowledge management. We specialize in leveraging advanced AI technologies to enhance
    customer support experiences, ensuring fast, accurate, and personalized responses.`,
    logo: MusadanLogo,
    target: "90001",
    companyId: "90001"
  },
  {
    id: 2,
    name: "Rama Lusaniya",
    description: `Located in the heart of Wandegeya, we’re your go-to spot for delicious meals delivered straight to your door! Specializing in crispy whole chicken & chips, aromatic pilau, golden plain chips, and hearty platters perfect for sharing, our menu is designed to satisfy every craving. Whether you’re fueling up for the day or hosting a casual gathering, we bring flavor-packed meals to your home or office with ease. Quick, convenient, and always fresh—order now and let Wandegeya Delights handle the cooking!`,
    logo: RamaLogo,
    target: "90001",
    companyId: "90002"
  },
  {
    id: 5,
    name: "Cafe Javas",
    description: `Cafe Javas, a quick-casual restaurant under the Mandela Group,
    offers a welcoming dining experience with over 300 menu items
    across 12 locations in Kampala and Entebbe. Known for freshly
    ground coffee and attentive service, Cafe Javas provides dine-in
    and delivery options, operating daily from 6:30 AM with varying
    closing times`,
    logo: CafeJavaLogo,
    target: "90001",
    companyId: "90003"
  },
  {
    id: 3,
    name: "Shell Wandegeya",
    description: `Shell Wandegeya located in the heart of Wandegeya, Kampala, is a 
    trusted provider of high-quality fuel and energy products, including petrol, diesel, 
    LPG (gas), and premium lubricants. Committed to safety, efficiency, and customer 
    satisfaction, the company serves individuals, businesses, and industries with 
    reliable, competitively priced solutions sourced from reputable suppliers. 
    Emphasizing eco-conscious practices, they promote clean-burning LPG and sustainable 
    energy use while ensuring fast service, doorstep delivery options, and expert 
    guidance. Strategically positioned and community-focused, Wandegeya Energy Solutions 
    strives to power progress and enhance lives through accessible, safe, and 
    environmentally responsible energy services.`,
    logo: ShellLogo,
  },
  {
    id: 4,
    name: "Shell Kyambogo",
    description: `Shell Kyambogo located in the heart of Kyambogo, Kampala, is a 
    trusted provider of high-quality fuel and energy products, including petrol, diesel, 
    LPG (gas), and premium lubricants. Committed to safety, efficiency, and customer 
    satisfaction, the company serves individuals, businesses, and industries with 
    reliable, competitively priced solutions sourced from reputable suppliers. 
    Emphasizing eco-conscious practices, they promote clean-burning LPG and sustainable 
    energy use while ensuring fast service, doorstep delivery options, and expert 
    guidance. Strategically positioned and community-focused, Wandegeya Energy Solutions 
    strives to power progress and enhance lives through accessible, safe, and 
    environmentally responsible energy services.`,
    logo: ShellLogo,
  },
  {
    id: 6,
    name: "Emin Pasha Hotel",
    description: `The Emin Pasha Hotel and Spa, where a collage of history, culture, and nature embrace you in a pouch of serenity! Just like Emin Pasha, the distinguished physician and anthropologist, The Emin Pasha Hotel and Spa embodies a bold spirit of unity, humanity and an appreciation of nature’s marvels.`,
    logo: EminPashaLogo,
  },
  {
    id: 7,
    name: "Jlos",
    description: `The Justice Law and Order Sector (JLOS) is a sector-wide approach that brings together eighteen (18) institutions with closely linked mandates responsible for administering justice, maintaining law and order and promoting the observance of human rights. JLOS is a major player in the promotion of the rule of law in Uganda. Through a sector-wide approach (SWAp), JLOS brings together state and non-state actors who play complementary roles in planning, budgeting, programme implementation, monitoring and evaluation.`,
    logo: JlosLogo,
  },
  {
    id: 8,
    name: "First Pharmacy",
    description: `First Pharmacy Uganda Limited is a trusted name and is a one stop destination to buy medicine online that gets delivered at your doorstep in no time. We make every online medicine order simple and hasslefree for our customers.`,
    logo: FirstPharmacyLogo,
  },
  {
    id: 9,
    name: "Gs Restuarant",
    description: `We serve different kinds of dishes with particular emphasis to local Ugandan food. Known for our legendary`,
    logo: GsRestaurantLogo,
  },
  {
    id: 10,
    name: "Rahim Foods",
    description: `We serve different kinds of dishes with particular emphasis to local Ugandan food. Known for our legendary`,
    logo: RahimLogo,
  },
];

interface useDashboardReturn {
  open: boolean;
  isSuspended: boolean;
  processedData: CompanyDataProps[];
  isPlatformCordova?: boolean;
  selectedCompany: string;
  searchQuery: string;
  isLoading: boolean;
  setSearchQuery: (query: string) => void;
  handleCloseModal: () => void;
  handleRegister: (company: CompanyDataProps) => void;
  handleCall: () => Promise<void>;
  handleNavigateToCompanyDetails: (id: number) => void;
}

const useDashboard = (): useDashboardReturn => {
  const [sipData, setSipData] = useState<SipDataProps>({
    password: "",
    uri: "",
    username: "",
    wss: "",
  });
  const [open, setOpen] = useState(false);
  const [isSuspended, setIsSuspended] = useState(true);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [target, setTarget] = useState<string | undefined>();
  const [companyId, setCompanyId] = useState<string | undefined>();
  const [isPlatformCordova, setIsPlatformCordova] = useState<boolean>();
  const [user, setUser] = useState<UserProfileProps | null>(null);
  const handleClose = () => setOpen(false);
  const { notify } = useToast();
  const { connectAndRegister, sessionManager, registerStatus, connectStatus } =
    useSIPProvider();
  const { isLoading, setIsLoading } = useLoading();
  const [searchQuery, setSearchQuery] = useState("");

  const handleGetAuthData = async () => {
    let authData: UserProfileProps | null = null;
    if (isPlatform("cordova")) {
      authData = (await getCordovaAuthData()) as unknown as UserProfileProps;
    } else {
      authData = getAuthData() as unknown as UserProfileProps;
    }
    return authData;
  };

  const navigate = useNavigate();
  const [qrCodeSearchParams] = useSearchParams();
  const searchParamCompanyId = qrCodeSearchParams.get("qrcode-companyid");
  const location = useLocation();
  const searchParams = location.search;

  const handleFetchOrganisations = async () => {
    try {
      const response = await getAllOrganizations();
    } catch (error) {
    }
    
  }

  useEffect (() => {
    handleFetchOrganisations();
  }, []);

  useEffect(() => {
    setIsPlatformCordova(isPlatform("cordova"));
    const fetchUser = async () => {
      const authData = await handleGetAuthData();
      if (!authData) {
        logoutUser();
        navigate(location.pathname === "/register" ? `/register${searchParams}` : `/login${searchParams}`);
      } else {
        setUser(authData); // Set user state
      }
    };
    fetchUser();
  }, []);

  useEffect(() => {
    if (user) {
      const fetchData = async () => {
        try {
          const response = await getRealTimeCallApi(user.userId);
          setSipData(response.data);
        } catch (error) {
          // notify("Failed to fetch real-time call data", ToastType.ERROR);
          logoutUser();
          navigate("/login");
        }
      };
      fetchData();
    }
  }, [user]);


  const processedData: CompanyDataProps[] = useMemo(() => {
    let data = [...registeredCompanies];

    if (searchQuery) {
      data = data.filter((company) =>
        company.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }
    return data;
    
  },[searchQuery, registeredCompanies]);

  // const handleCall = async () => {
  //   console.log("::debug handleCall innitiated:");
  //   const extraHeaders = [`User-Id: ${user?.userId}`];
  //   try {
  //     await sessionManager?.call(`sip:${target}@93.127.162.61`, {extraHeaders});
  //     navigate("/outbounding-call");
  //   } catch (error) {
  //     console.log("::debug handleCall innitiated error:", error);
  //     notify("Failed to initiate call, try again!!!", ToastType.ERROR);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleCall = async () => {
    const extraHeaders = [`USER-ID: ${user?.userId}`, `COMPANY-ID: ${companyId}`];

    try {
      // Check if media devices are available
      // const devices = await navigator.mediaDevices.enumerateDevices();
      // if (devices.length === 0) {
      //   console.log("No media devices available");
      //     throw new Error("No media devices available");
      // }

      await sessionManager?.call(`sip:${target}@93.127.162.61`, {
        extraHeaders,
      });
      navigate("/outbounding-call", {
        state: {
          selectedCompany: selectedCompany
        }
      });
    } catch (error) {
      notify("Failed to initiate call, try again!!!", ToastType.ERROR);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (
      connectStatus === CONNECT_STATUS.CONNECTED &&
      registerStatus === RegisterStatus.REGISTERED
    ) {
      handleCall();
    }
  }, [connectStatus, registerStatus]);

  useEffect(() => {
    if (searchParams.includes("qrcode-companyid")) {
      const selectedCompany = registeredCompanies.find(
        (company) => company.companyId === searchParamCompanyId
      );

      if (selectedCompany && sipData.username  && sipData.password) {
        handleRegister(selectedCompany);
      }
    } else {
      setIsSuspended(false);
    }
  }, [searchParams, sipData]);

  const handleRegister = (company: CompanyDataProps) => {
    setSelectedCompany(company.name);
    if(company.target && company.companyId) {
      setIsLoading(true);
      setTarget(company.target);
      setCompanyId(company.companyId);
      const { password, username } = sipData;
      const account: SIPAccount = { username, password };
      connectAndRegister(account);
    } else {
      setOpen(true);
    }
  };

  

  const handleCloseModal = () => {
    setIsLoading(false);
    handleClose();
  };

  const handleNavigateToCompanyDetails = (id: number) => {
    navigate(`/company-details?id=${id}`);
  };

  return {
    open,
    searchQuery,
    processedData,
    isPlatformCordova,
    selectedCompany,
    isLoading,
    isSuspended,
    setSearchQuery,
    handleCloseModal,
    handleRegister,
    handleCall,
    handleNavigateToCompanyDetails,
  };
};

export default useDashboard;
